import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import { Box, Typography } from "@mui/material";

function ComplexStatisticsCard({ color, title, count, icon, desc, handleClick }) {
    return (
        <Card>
            <Box display="flex" justifyContent="space-between" pt={1} px={2}>
                <Icon fontSize="medium" style={{ color: color }}>
                    {icon}
                </Icon>
                <Box
                    variant="gradient"
                    borderRadius="xl"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="4rem"
                    height="4rem"
                    mt={-3}
                >
                    {/* Add any content for the box here */}
                </Box>
                <Box textAlign="right" lineHeight={1.25}>
                    <Typography variant="button" fontWeight="light" color="text">
                        {title}
                    </Typography>
                    <Typography variant="h4">{count}</Typography>
                </Box>
            </Box>
            <Divider />
            <Box p={1} px={2}>
                <Typography component="p" variant="button" color="text" display="flex">
                    <Typography
                        component="span"
                        variant="button"
                        fontWeight="thin"
                        color={color === "success" ? "green" : color}
                        sx={{ cursor: "pointer", textTransform: 'none' }}
                        onClick={() => handleClick()}
                    >
                        {desc}
                    </Typography>
                </Typography>
            </Box>
        </Card>
    );
}

export default ComplexStatisticsCard;
